import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/ContactUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/Pricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/Samples.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/Sources.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/cpa/HighlightsCommercialisti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/cpa/PotentialMarketCommercialisti.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/AIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/Logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/IubendaLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/components/ui/accordion.tsx");
